import React from "react";
import { Mail, Phone, Facebook, Instagram, Linkedin, X, Youtube } from 'lucide-react';
import vivanetLogo from '../../assets/Vivanet_White Logo.svg';
import lionLogo from '../../assets/lionLogo.svg';

const WebsiteFooter = () => {
  const footerSections = [
    {
      title: "Legal",
      links: [
        { name: "Privacy", href: "/privacy-policy" },
        { name: "Terms", href: "/terms-of-service" },
        { name: "Enterprise Policy", href: "/terms-and-conditions" },
        { name: "User License", href: "/user-license" },
        { name: "Cookies & IP", href: "/cookies-and-ip" },
        { name: "Jurisdiction", href: "/jurisdiction" },
        { name: "Child Privacy", href: "/child-privacy" },
        { name: "Creators Agreement", href: "/creators-agreement" }
      ]
    },
    {
      title: "Policies",
      links: [
        { name: "Security", href: "/security" },
        { name: "Copyright", href: "/copyright" },
        { name: "Data Terms", href: "/data-terms" },
        { name: "Tax Info", href: "/tax-info" }
      ]
    },
    {
      title: "Transparency",
      links: [
        { name: "AI Use", href: "/ai-use" },
        { name: "Grievances", href: "/grievance" },
        { name: "Data Retention", href: "/data-retention" },
        { name: "Vendors", href: "/vendors" }
      ]
    },
    {
      title: "Support",
      links: [
        { name: "Help Center", href: "/help-center" },
        { name: "Ask Us", href: "/ask-us" },
        { name: "Schedule Call", href: "https://outlook.office365.com/owa/calendar/ProductDemo@ttlmedia.in/bookings/" },
        { name: "Contact", href: "/contact" }
      ]
    },
    {
      title: "Company",
      links: [
        { name: "Blog", href: "/blog" },
        { name: "News", href: "/news" },
        { name: "Jobs", href: "/jobs" }
      ]
    },
    {
      title: "Billing",
      links: [
        { name: "Billing Terms", href: "/billing-terms" }
      ]
    }
  ];

  const socialLinks = [
    { name: "LinkedIn", icon: Linkedin, href: "https://www.linkedin.com/company/oyecreators/" },
    { name: "Facebook", icon: Facebook, href: "http://facebook.com/oyecreators/" },
    { name: "Instagram", icon: Instagram, href: "https://www.instagram.com/oye_creators/" },
    { name: "YouTube", icon: Youtube, href: "https://www.youtube.com/@oyecreators" },
    { name: "X", icon: X, href: "https://x.com/oyecreators" },
    { name: "WhatsApp", icon: Phone, href: "https://wa.me/+918484965525" },
    { name: "Email", icon: Mail, href: "mailto:Support@ttlmedia.in" }
  ];

  return (
    <footer
      className="mt-auto relative overflow-hidden bg-custom-footer-gradient"
    >
      {/* Decorative gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-purple-600/20 to-transparent pointer-events-none"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Footer Links Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 mb-12">
          {footerSections.map(section => (
            <div key={section.title} className="space-y-4">
              <h3 className="text-sm font-semibold text-white uppercase tracking-wider border-b border-solid border-t-0 border-l-0 border-r-0 border-purple-400/30 pb-2">
                {section.title}
              </h3>
              <ul className="list-none space-y-3 p-0">
                {section.links.map(link => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      target={link.name === "Schedule Call" ? "_blank" : undefined}
                      rel={link.name === "Schedule Call" ? "noopener noreferrer" : undefined}
                      className="text-sm text-purple-200 hover:text-white transition-all duration-200 hover:translate-x-1 inline-block no-underline"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Logo Section (Aligned right) */}
        <div className="flex justify-end gap-8 mb-6">
          <img
            src={lionLogo}
            alt="Make in India"
            className="h-16 w-auto opacity-80 hover:opacity-100 transition-opacity"
          />
          <a className="v-logo-content" target="_blank" rel="noopener noreferrer" href="https://www.vivanet.in/">
            <img
              src={vivanetLogo}
              alt="Vivanet Logo"
              className="h-16 w-auto opacity-80 hover:opacity-100 transition-opacity"
            />
          </a>
        </div>

        {/* Bottom Section */}
        <div className="pt-4 border-t border-solid border-b-0 border-l-0 border-r-0 border-purple-400/30">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-purple-300">
              © 2025 TTL Media Private Limited All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <div className="flex gap-3">
                {socialLinks.map(social => {
                  const IconComponent = social.icon;
                  return (
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      key={social.name}
                      href={social.href}
                      className="w-8 h-8 bg-purple-700/50 hover:bg-purple-600 rounded-full flex items-center justify-center text-purple-200 hover:text-white transition-all duration-300 hover:scale-110"
                      aria-label={social.name}
                    >
                      <IconComponent size={14} />
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default WebsiteFooter;
